module.exports = __webpack_public_path__ + "static/media/backgroundAboutUs.f8580eae.jpg";